// extracted by mini-css-extract-plugin
export var modal = "_gm-0";